
const Footer = () => {
  return (
    <footer className="bg-[#1a2332] text-white py-10">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          {/* Company Name */}
          <h3 className="text-xl font-bold">Prime Connect</h3>
          
          {/* Contact Info */}
          <div className="text-gray-300 space-y-2 text-base leading-relaxed">
            <p>대표: 송정민</p>
            <p>
              이메일: <a 
                href="mailto:hello@lilyxglobal.com" 
                className="hover:text-white transition-colors"
              >
                hello@lilyxglobal.com
              </a>
            </p>
            <p>전화: 070-8983-7994</p>
            <p>주소: 서울특별시 영등포구 의사당대로 83 오투타워 20층</p>
          </div>
          
          {/* Copyright */}
          <div className="pt-4">
            <p className="text-[#999999] text-sm">© 2025 Prime Connect. All rights reserved.</p>
            <p className="text-xs text-[#888888] mt-2">
              <a href="https://readdy.ai/?ref=logo" className="hover:text-gray-300 transition-colors whitespace-nowrap">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
